import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../utils';
import { useAuth } from '@/contexts/AuthContext';
import {
  Plus,
  ArrowRight
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import { motion } from 'framer-motion';

export default function Home() {
  const { user, profile } = useAuth();

  const isAdmin = profile?.role === 'admin';

  return (
    <div className="min-h-screen">
      <section className="relative overflow-hidden min-h-screen">
        <div className="absolute inset-0">
          <img
            src="/landing-page_bg.png"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <div className="mb-8">
              <img
                src="/slidepusher_events.svg"
                alt="Slidepusher Events"
                className="h-36 mb-6"
              />
              <h1 className="text-3xl font-semibold text-white">Production Portal</h1>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              {user ? (
                <>
                  <Link to={createPageUrl('Events')}>
                    <Button size="lg" className="bg-primary-500 text-white hover:bg-primary-600 border-primary-500 h-12 px-6">
                      View Events
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                  {isAdmin && (
                    <Link to={createPageUrl('CreateEvent')}>
                      <Button size="lg" variant="outline" className="border-zinc-700 text-zinc-300 hover:bg-zinc-800/50 hover:text-white hover:border-zinc-600 h-12 px-6">
                        <Plus className="w-4 h-4 mr-2" />
                        New Event
                      </Button>
                    </Link>
                  )}
                </>
              ) : (
                <Link to={createPageUrl('Login')}>
                  <Button
                    size="lg"
                    className="bg-primary-500 text-white hover:bg-primary-600 border-primary-500 h-12 px-8"
                  >
                    Get Started
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              )}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
